export default __webpack_public_path__ + "static/challengeBanner-b8db920cf258ea56232ebbd80d87d466.mp4";